const resumeData = {
  updatedText: "* Updated in January, 2026",
  actions: [
    { label: "View Resume", href: "/viewResume", target: "_blank" },
    { label: "Download Resume", type: "download", target: "_blank" },
    {
      label: "Forward To Whatsapp",
      href: "whatsapp://send?text=Resume of Subhadip Das: https://subhadipdas.innovexdev.com/viewResume",
      target: "_blank",
    },
  ],
};

export default resumeData;
